
const RecipeIngredients = () => {
  return (
    <>
      <h2 className="text-2xl font-medium mb-4">Ingredients</h2>
      <div className="bg-secondary/50 p-6 rounded-lg mb-8 border border-secondary">
        <ul className="list-disc pl-5 text-muted-foreground space-y-2">
          <li>2 large egg whites, room temperature</li>
          <li>½ cup granulated sugar</li>
          <li>¼ teaspoon salt</li>
          <li>¼ cup unsalted butter, melted and cooled</li>
          <li>½ teaspoon vanilla extract</li>
          <li>¼ teaspoon almond extract (optional but recommended)</li>
          <li>⅔ cup all-purpose flour</li>
          <li>2 tablespoons water</li>
          <li>Small strips of paper for fortunes (approximately 3" × ½")</li>
        </ul>
      </div>

      <h2 className="text-2xl font-medium mb-4">Special Equipment</h2>
      <div className="bg-secondary/50 p-6 rounded-lg mb-8 border border-secondary">
        <ul className="list-disc pl-5 text-muted-foreground space-y-2">
          <li>Non-stick baking mats or parchment paper</li>
          <li>Small offset spatula</li>
          <li>Round cookie cutter (3") or glass to trace circles</li>
          <li>Muffin tin (to help cookies hold their shape while cooling)</li>
          <li>Heat-resistant gloves</li>
        </ul>
      </div>
    </>
  );
};

export default RecipeIngredients;
